import React, { memo } from "react";
import { Box, FormControlLabel, Grid } from "@mui/material";
import { FormikProps, getIn, useFormikContext } from "formik";
import { includes } from "ramda";
import { Bin, Data } from "../../../store/processor/types";
import CustomizedCheckbox from "../../../common/formElements/Checkbox";
import TextInput from "../../../common/formElements/TextInput";

interface ProcessorBinForm {
  index: number;
  bin: Bin;
}

const ProcessorBinForm = (props: ProcessorBinForm) => {
  const { index, bin } = props;
  const { values, setFieldValue } = useFormikContext<FormikProps<Data>>();
  const accounts = ["Cheque", "Savings", "Credit", "Default"];

  return (
    <Grid container alignItems="flex-start" spacing={2}>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center">
          <Box mr={2}>Accounts: </Box>
          {accounts.map((account: string, idx) => {
            return (
              <FormControlLabel
                key={`${idx}_${bin.Account.length}`}
                control={
                  <CustomizedCheckbox
                    checked={includes(account, bin.Account)}
                    onChange={(e) => {
                      const currentAccounts = getIn(
                        values,
                        `attributes.Bin[${index}.Account]`
                      );
                      if (e.currentTarget.checked) {
                        setFieldValue(`attributes.Bin[${index}].Account`, [
                          ...currentAccounts,
                          account,
                        ]);
                      } else {
                        setFieldValue(
                          `attributes.Bin[${index}].Account`,
                          currentAccounts.filter(
                            (x: string) =>
                              x.toLowerCase() !== account.toLowerCase()
                          )
                        );
                      }
                    }}
                    name="account"
                  />
                }
                label={account}
              />
            );
          })}
        </Box>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput fieldname={`attributes.Bin[${index}].From`} label="From" />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput fieldname={`attributes.Bin[${index}].To`} label="To" />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Bin[${index}].Length`}
          label="Length"
          type="number"
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Bin[${index}].AmountFrom`}
          label="Amount From"
          type="number"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Bin[${index}].AmountTo`}
          label="Amount To"
          type="number"
        />
      </Grid>
    </Grid>
  );
};

export default memo(ProcessorBinForm);
